/**  Типы полей */
export const fieldsTypes: {
    digit: string; // Число
    bool: string; // Да/Нет
    date: string; // Дата
    string: string; // Строка
    text: string; // Текст
    list: string; // Список
    registry: string; // Список
    address: string; // Адрес
    numerator: string; // Нумератор
    access: string; // Доступы
    technicalProcess: string; // Технический процесс
} = {
    digit: 'digit',
    bool: 'bool',
    date: 'date',
    string: 'string',
    text: 'text',
    list: 'list',
    registry: 'registry',
    address: 'address',
    numerator: 'numerator',
    access: 'access',
    technicalProcess: 'technical_process',
};
